/**
 * TC dashboard numbers and tones (TC-DASHBOARD-V2-DESIGN §3–4). Pure functions; amounts are numbers.
 */

const num = (v) => (v === null || v === undefined || v === '' ? null : Number(v));

// Change vs the previous period: whole-percent, or 'new' when there is nothing to compare with
export const delta = (current, previous) => {
  const c = num(current) || 0;
  const p = num(previous);
  if (!p && !c) return { pct: 0, direction: 'flat' };
  if (!p) return { pct: null, direction: 'new' };
  const pct = Math.round(((c - p) / Math.abs(p)) * 100);
  return { pct, direction: pct > 0 ? 'up' : pct < 0 ? 'down' : 'flat' };
};

export const marginPct = (profit, revenue) => {
  const r = num(revenue);
  return r ? (num(profit) / r) * 100 : null;
};

// Cash & bank minus the customer wallet money held in it
export const ownMoney = (cash, customerWallets) => (num(cash) || 0) - (num(customerWallets) || 0);

// Share of receivables past due (everything except `current`), whole percent
export const overduePct = ({ current = 0, d1to30 = 0, d31to60 = 0, d60plus = 0 } = {}) => {
  const total = Number(current) + Number(d1to30) + Number(d31to60) + Number(d60plus);
  return total ? Math.round(((total - Number(current)) / total) * 100) : 0;
};

export const expiryTone = (daysLeft) => (daysLeft <= 7 ? 'red' : daysLeft <= 30 ? 'amber' : 'grey');
export const marginTone = (pct) => (pct < 10 ? 'red' : pct < 30 ? 'amber' : 'green');

const whole = (n) => Math.round(num(n) || 0).toLocaleString('en-US');
export const formatAed = (n) => `AED ${whole(n)}`;
export const formatSigned = (n) => {
  const v = Math.round(num(n) || 0);
  return v > 0 ? `+${whole(v)}` : whole(v);
};
export const formatCompact = (n) => {
  const v = num(n) || 0;
  if (Math.abs(v) >= 1000000) return `${(v / 1000000).toFixed(1)}M`;
  if (Math.abs(v) >= 1000) return `${(v / 1000).toFixed(1)}K`;
  return String(Math.round(v));
};
